import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site-info';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href={siteInfo.socialLinks.wechat} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href={siteInfo.socialLinks.douyin} target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#video-categories" className="hover:text-primary-500 transition-colors">视频分类</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#quick-links" className="hover:text-primary-500 transition-colors">快速链接</a>
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#terms" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  服务条款
                </a>
              </li>
              <li>
                <a href="#help" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  帮助中心
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-sm text-foreground-500 mt-0.5"></i>
                <span className="text-sm text-foreground-600">{siteInfo.contact.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-sm text-foreground-500 mt-0.5"></i>
                <span className="text-sm text-foreground-600">{siteInfo.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-sm text-foreground-500 mt-0.5"></i>
                <span className="text-sm text-foreground-600">{siteInfo.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteInfo.name} - {siteInfo.tagline} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-primary-500 transition-colors">
              京ICP备2024000001号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}